import React from 'react';
// import FAIcon from '@fortawesome/react-fontawesome';

// import { faTrophyAlt } from 'src/components/icons';
import { intercomAppID } from 'src/config';
import './contact.css';

export default class Contact extends React.Component {
	render() {
		return (
			<section className="contact">
				<h2 className="contact-title">Get in touch.</h2>
				<div className="contact-body">
					<div className="contact-body-text">
						Whether you're a team, a broadcaster, or a player, our tools can help you change the
						game. Let us know what you're thinking; we're here to help.
					</div>
				</div>
				<a
					className="button contact-button intercom"
					href={`mailto:${intercomAppID}@incoming.intercom.io`}>
					Contact sales
				</a>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/contact.js